

/**
 * 用法
 * on('.xxx','click',()=>{console.log('click')})
 * on(document.getElementById('xxx'),'click',()=>{console.log('click')})
 * on(document.querySelectorAll('xxx'),'click',()=>{console.log('click')})
 * on(document.querySelector('xxx'),'click',()=>{console.log('click')})
 * 
 * 可以加上第三个参数
 * on(document.querySelector('xxx'),'click',()=>{console.log('click')})
 * 
 */

export interface CustomEventListener<T = any> {
  guid?: number,
  (ev: T): void;
}
// 定义函数签名
interface OnFunction {
  (
    element: string | Element | NodeList | Window | Document | EventTarget | Element[],
    eventType: keyof DocumentEventMap,
    listener: CustomEventListener,
    options?: boolean | AddEventListenerOptions
  ): { off: () => void };
  (
    element: string | Element | NodeList | Window | Document | EventTarget | Element[],
    eventType: keyof DocumentEventMap,
    selector: string,
    listener: CustomEventListener,
    options?: boolean | AddEventListenerOptions
  ): { off: () => void };
}

let guid = 0;

const dispatchEvent = (event: Event, selector: string, handler: CustomEventListener) => {
  let node = event.target as HTMLElement | null;

  // 事件队列
  const handlerQueue = [];

  // 如果不是右键点击
  if (!(event.type == 'click' && (event as MouseEvent).button > 1)) {

    while (node) {
      // nodeType表示是Element元素，如果是点击的话，那点击对象就不能是disabled
      if (node.nodeType === 1 && !(event.type === "click" && (node as HTMLInputElement).disabled === true)) {
        if (node.matches(selector)) {
          // console.log('node.nodeType match ', node.nodeType)
          if (typeof handler === 'function') {
            // (handler as CustomEventListener)(event);
            handler.call(node, event);
          }
        }
      }
      node = node.parentNode as HTMLElement | null;
    }
  }
};


export const on: OnFunction = <K extends keyof DocumentEventMap> (element: string | Element | NodeList | Window | Document | EventTarget | Element[],
  eventType: K,
  ...args: [listener: CustomEventListener, options?: boolean | AddEventListenerOptions] | [selector: string, listener: EventListenerOrEventListenerObject | CustomEventListener, options?: boolean | AddEventListenerOptions]
): { off: () => void } => {
  if (!element) {
    return { off: () => { } };
  }
  const elements =
    typeof element === "string" ? document.querySelectorAll<HTMLElement>(element) :
      (element instanceof NodeList || element instanceof Array) ? element : [element];

  let selector: string | undefined;
  let listener: CustomEventListener;
  let options: boolean | AddEventListenerOptions | undefined;

  if (typeof args[0] === "string") {
    [selector, listener, options] = args as [string, CustomEventListener, boolean | AddEventListenerOptions];
  } else {
    [listener, options] = args as [CustomEventListener, boolean | AddEventListenerOptions];
  }
  if (!listener.guid) {
    listener.guid = ++guid;
  }

  if (selector) {
    elements.forEach((item: any) => {
      // 如果有选择器，就要进行包装处理
      item.addEventListener(eventType, (event: Event) => {
        dispatchEvent(event, selector!, listener);
      }, options);
    });
  } else {
    elements.forEach((item: any) => {
      item.addEventListener(eventType, listener, options);

    });

  }


  return {
    off () {
      elements.forEach((item: any) => {
        item.removeEventListener(eventType, listener, options);
      });
    }
  }

  // if (typeof els === 'string') {
  //   const elements = document.querySelectorAll(els);

  //   elements.forEach(f => {
  //     f.addEventListener(eventType, listener, options);
  //   });

  //   return {
  //     off () {
  //       elements.forEach(f => {
  //         f.removeEventListener(eventType, listener, options);
  //       });
  //     }
  //   }
  // }
  // else if (els instanceof NodeList) {
  //   els.forEach(f => {
  //     f.addEventListener(eventType, listener, options);
  //   });

  //   return {
  //     off () {
  //       els.forEach(f => {
  //         f.removeEventListener(eventType, listener, options);
  //       });
  //     }
  //   }
  // } else {

  //   els.addEventListener(eventType, listener, options);
  //   return {
  //     off () {
  //       els.removeEventListener(eventType, listener, options);
  //     }
  //   };
  // }
}